export const UI = {
  fr: {
    story: "Bienvenue",
    presentation: "Présentation",
    works: "Travaux",
    about: "À propos",
    heroEyebrow: "Journalisme · Télévision · Vidéo",
    heroTagline: "Trois langues, plusieurs perspectives, un monde à raconter",
    scrollHint: "Défiler",
    stepsEyebrow: "Sept étapes",
    worksEyebrow: "Étape 8",
    worksTitle: "Portfolio",
    worksDesc: "Voici quelques exemples de travaux :",
    pieces: "reportages",
    open: "Ouvrir",
    close: "Fermer",
    aboutEyebrow: "Dernière étape",
    aboutTitle: "À propos de moi",
    gateEyebrow: "Choisissez votre langue",
    marquee: "Journalisme — Télévision — Vidéo — Reportage — Documentaire — Portrait — ",
    watch: "Regarder",
    contactNav: "Contact",
    contactEyebrow: "Contact",
    contactTitle: "Travaillons ensemble",
    contactText: "Pour un projet télévisé, un reportage vidéo ou une présentation.",
    contactNote: "Coordonnées provisoires — à remplacer par les vôtres.",
  },
  de: {
    story: "Willkommen",
    presentation: "Moderation",
    works: "Arbeiten",
    about: "Über mich",
    heroEyebrow: "Journalismus · Fernsehen · Video",
    heroTagline: "Drei Sprachen, unzählige Perspektiven, eine Welt voller Geschichten.",
    scrollHint: "Scrollen",
    stepsEyebrow: "Sieben Schritte",
    worksEyebrow: "Schritt 8",
    worksTitle: "Portfolio",
    worksDesc: "Hier einige Beispiele meiner Arbeiten:",
    pieces: "Reportagen",
    open: "Öffnen",
    close: "Schließen",
    aboutEyebrow: "Letzter Schritt",
    aboutTitle: "Über mich",
    gateEyebrow: "Wählen Sie Ihre Sprache",
    marquee: "Journalismus — Fernsehen — Video — Reportage — Dokumentation — Porträt — ",
    watch: "Ansehen",
    contactNav: "Kontakt",
    contactEyebrow: "Kontakt",
    contactTitle: "Lassen Sie uns zusammenarbeiten.",
    contactText: "Für ein Fernsehprojekt, eine Videoreportage oder eine Moderation.",
    contactNote: "Vorläufige Angaben — bitte durch Ihre eigenen ersetzen.",
  },
  en: {
    story: "Welcome",
    presentation: "Presentation",
    works: "Work",
    about: "About",
    heroEyebrow: "Journalism · Television · Video",
    heroTagline: "Three languages, countless perspectives, one world of stories.",
    scrollHint: "Scroll",
    stepsEyebrow: "Seven Steps",
    worksEyebrow: "Step 8",
    worksTitle: "Portfolio",
    worksDesc: "Here are some examples of my work:",
    pieces: "reports",
    open: "Open",
    close: "Close",
    aboutEyebrow: "Final step",
    aboutTitle: "About me",
    gateEyebrow: "Choose your language",
    marquee: "Journalism — Television — Video — Reportage — Documentary — Portrait — ",
    watch: "Watch",
    contactNav: "Contact",
    contactEyebrow: "Contact",
    contactTitle: "Let's work together",
    contactText: "For a television project, a video report or a hosting.",
    contactNote: "Placeholder details — replace with your own.",
  },
};

// À REMPLACER : vraies coordonnées de Pia (adresse mail et numéro)
export const CONTACT_INFO = {
  email: "piado@gmx.net",
  phone: "+33 6 00 00 00 00",
  instagram: "https://instagram.com/pia.dolesch",
  tiktok: "https://tiktok.com/@pia.dolesch",
};

export const LANGS = [
  { code: "fr", label: "Français" },
  { code: "de", label: "Deutsch" },
  { code: "en", label: "English" },
];

export const STEPS = [
  {
    title: { fr: "Bonjour et bienvenue dans mon univers !", de: "Servus und willkommen!", en: "Hello and welcome!" },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-1.jpeg",
  },
  {
    title: { fr: "Je m'appelle Pia Dolesch.", de: "Mein Name ist Pia Dolesch.", en: "My name is Pia Dolesch." },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-2.webp",
    pos: "top",
  },
  {
    title: {
      fr: "Ma mission : informer, offrir de nouvelles perspectives et élargir les horizons.",
      de: "Mein Ziel: informieren, neue Perspektiven bieten und Horizonte erweitern.",
      en: "My mission is to inform, offer new perspectives and broaden horizons.",
    },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-3.webp",
    pos: "top",
  },
  {
    title: {
      fr: "Ma licence en communication transculturelle en allemand, anglais et français, m'a appris à quel point il est important d'adapter l'information au contexte culturel et linguistique de chaque public.",
      de: "Mein Studium der transkulturellen Kommunikation auf Deutsch, Englisch und Französisch hat mir gelehrt, wie wichtig es ist, Informationen auf den kulturellen und sprachlichen Kontext des jeweiligen Publikums anzupassen.",
      en: "Having studied intercultural communication in German, English and French, I understand the importance of tailoring information to the cultural and linguistic context of each audience.",
    },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-4.png",
  },
  {
    title: {
      fr: "Une seconde licence en Media Reporting et un master en journalisme télévisé m'ont donné les moyens d'y parvenir.",
      de: "Ein zweiter Bachelor in Media Reporting und ein Masterstudium in TV-Journalismus haben mir das nötige Handwerk dafür vermittelt.",
      en: "A second bachelor's in media reporting and a master's in TV journalism gave me the skills to do it.",
    },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-5.webp",
  },
  {
    title: { fr: "Pourquoi plusieurs langues ?", de: "Warum mehrere Sprachen?", en: "Why different languages?" },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-6-b.webp",
  },
  {
    title: {
      fr: "Parce que l'information ne doit pas s'arrêter aux frontières, ni oublier ceux à qui elle s'adresse.",
      de: "Damit Informationen Grenzen überwinden und dabei trotzdem verständlich bleiben.",
      en: "Because I want information to cross borders and still be understood.",
    },
    text: { fr: "", de: "", en: "" },
    img: "/images/step-7.webp",
  },
];

// Remplacez link: "#" par l'URL de votre reportage / vidéo pour chaque travail
export const CATEGORIES = [
  {
    id: "grands-reportages",
    title: { fr: "Présentatrice / Reporter de terrain", de: "Moderatorin / Reporterin vor Ort", en: "Presenter / Field Reporter" },
    subtitle: { fr: "À l'antenne et sur le terrain", de: "Vor der Kamera und im Einsatz", en: "On air and in the field" },
    count: 3,
    img: "/images/work-reporter-e.webp",
    items: [
      {
        year: "",
        link: "https://youtu.be/n5iaByYYmrY",
        title: { fr: "Duplex : La France partage-t-elle sa dissuasion nucléaire ?", de: "Duplex : La France partage-t-elle sa dissuasion nucléaire ?", en: "Duplex : La France partage-t-elle sa dissuasion nucléaire ?" },
        excerpt: { fr: "Présentatrice TV — duplex", de: "TV-Moderatorin — Live-Schalte", en: "TV presenter — live duplex" },
        orig: { fr: "« en français »", de: "„auf Französisch“", en: "“in French”" },
      },
      {
        year: "",
        link: "https://youtu.be/psviq_-2Mqc",
        title: { fr: "Duplex: France and Germany deepen defense cooperation: What does it mean for the UK?", de: "Duplex: France and Germany deepen defense cooperation: What does it mean for the UK?", en: "Duplex: France and Germany deepen defense cooperation: What does it mean for the UK?" },
        excerpt: { fr: "Reporter de terrain — duplex", de: "Reporterin vor Ort — Live-Schalte", en: "Field reporter — live duplex" },
        orig: { fr: "« en anglais »", de: "„auf Englisch“", en: "“in English”" },
      },
      {
        year: "",
        link: "https://youtu.be/2egVGQL2Fcw",
        title: { fr: "Duplex : comment la France et l'Allemagne repensent la sécurité de l'Europe ?", de: "Liveschaltung: Wie stellen Frankreich und Deutschland Europas Sicherheit neu auf?", en: "Live link-up: how are France and Germany reshaping Europe's security?" },
        excerpt: { fr: "Présentatrice TV — duplex", de: "TV-Moderatorin — Liveschaltung", en: "TV presenter — live link-up" },
      },
    ],
  },
  {
    id: "portraits-interviews",
    title: { fr: "JRI", de: "Kamerajournalistin", en: "Camera journalist" },
    subtitle: { fr: "Tournage et montage", de: "Dreh und Schnitt", en: "Filming and editing" },
    count: 4,
    img: "/images/work-jri-new.jpg",
    pos: "75% 50%",
    items: [
      {
        year: "",
        link: "https://youtu.be/chNto_wFX20",
        title: { fr: "Des détectives pour traquer les déchets sauvages", de: "Ermittler auf der Spur illegaler Müllablagerungen", en: "Detectives to track down fly-tipping" },
        excerpt: { fr: "JRI & rédaction", de: "Kamerajournalistin & Redaktion", en: "VJ & writing" },
      },
      {
        year: "",
        link: "https://youtu.be/ESENH5cZOsw",
        title: { fr: "Dry January : le sans-alcool fait recette", de: "„Dry January“: Der Trend zum Alkoholverzicht setzt sich durch", en: "Dry January: alcohol-free drinks are proving a hit" },
        excerpt: { fr: "JRI", de: "Kamerajournalistin", en: "VJ" },
      },
      {
        year: "",
        link: "https://youtu.be/9ks3Aga_ngA",
        title: { fr: "Portrait croisé : les jeunes s'engagent en politique municipale", de: "Sammelportrait: Das Engagement junger Menschen in der Lokalpolitik", en: "Cross-portrait: the youth getting involved in local politics" },
        excerpt: { fr: "JRI", de: "Kamerajournalistin", en: "VJ" },
      },
      {
        year: "",
        link: "https://youtu.be/OtZWvCP4qnQ",
        title: { fr: "Slasheurs : une nouvelle façon de travailler… ou de s'épuiser ?", de: "Slasher: zwischen Ausbeutung und beruflicher Erfüllung", en: "Slashers: a new way of working… or a path to burnout?" },
        excerpt: { fr: "JRI & rédaction", de: "Kamerajournalistin & Redaktion", en: "VJ & writing" },
      },
    ],
  },
  {
    id: "enquetes-investigations",
    title: { fr: "Productrice / Rédactrice", de: "Produzentin / Redakteurin", en: "Producer / Editor" },
    subtitle: { fr: "Conception et écriture des formats", de: "Konzeption und Text der Formate", en: "Designing and writing formats" },
    count: 6,
    img: "/images/work-producer-a.png",
    items: [
      {
        year: "",
        link: "https://youtu.be/fl_0ubxOpig",
        title: { fr: "Allemagne : des chenilles urticantes à Berlin", de: "Berlin: Ausbreitung giftiger Raupen sorgt für Besorgnis", en: "Berlin: the spread of poisonous caterpillars is causing concern" },
        excerpt: { fr: "Rédactrice", de: "Redakteurin", en: "Editor" },
      },
      {
        year: "",
        link: "https://www.instagram.com/reel/DZFCPa-s1Xb/",
        title: { fr: "Marc Bloch : l'Allemagne restitue des ouvrages à sa famille", de: "Marc Bloch: Deutschland gibt Werke an seine Familie zurück", en: "Marc Bloch: Germany returns his works to his family" },
        excerpt: { fr: "Co-rédactrice", de: "Mitautorin", en: "Co-author" },
      },
      {
        year: "",
        link: "https://afleurdevoix.esj-lille.net/mon-reve-denfance-et-si-tout-sarrete-demain/",
        title: { fr: "Mon rêve d'enfance, et si tout s'arrête demain ? (journalisme intime)", de: "Mein Kindheitstraum – und wenn morgen alles vorbei ist? (Intimjournalismus)", en: "My childhood dream – what if it all came to an end overnight? (intimate journalism)" },
        excerpt: { fr: "Podcast", de: "Podcast", en: "Podcast" },
      },
      {
        year: "",
        link: "https://youtu.be/lLfgiWZqb0I",
        title: { fr: "Comment les hôpitaux garantissent-ils la disponibilité et la salubrité de l'eau ? (version allemande avec sous-titres en anglais)", de: "Wie gewährleisten Krankenhäuser die Wasserversorgung und -sicherheit?", en: "How do hospitals guarantee water capacity and safety? (german version with english subtitles)" },
        excerpt: { fr: "Productrice de long format", de: "Autorin von Langformaten", en: "Author of extended formats" },
      },
      {
        year: "",
        link: "https://youtu.be/OtZWvCP4qnQ",
        title: { fr: "Slasheurs : une nouvelle façon de travailler… ou de s'épuiser ?", de: "Slasher: zwischen Ausbeutung und beruflicher Erfüllung", en: "Slashers: a new way of working… or a path to burnout?" },
        excerpt: { fr: "Rédactrice & JRI", de: "Redakteurin & Kamerajournalistin", en: "Editor & VJ" },
      },
      {
        year: "",
        link: "https://youtu.be/thMCAoKMkBs",
        title: { fr: "Fusion des communes : une solution pour l'avenir des territoires ?", de: "Zusammenlegung von Gemeinden: die Lösung für die Zukunft französischer Kommunen?", en: "Merging local authorities: the solution for the future of local areas?" },
        excerpt: { fr: "Rédactrice", de: "Redakteurin", en: "Editor" },
      },
    ],
  },
  {
    id: "essais-billets",
    title: { fr: "Réseaux sociaux", de: "Soziale Netzwerke", en: "Social Media" },
    subtitle: { fr: "Formats courts et narration digitale", de: "Kurzformate und digitales Storytelling", en: "Short formats and digital storytelling" },
    count: 7,
    img: "/images/work-social.jpg",
    items: [
      {
        year: "",
        link: "https://www.instagram.com/reel/DZ0JUTJpJCs/",
        title: { fr: "Dans les coulisses de la plus grande salle de MMA d'Europe", de: "Ein Blick hinter die Kulissen der größten MMA-Halle Europas", en: "Behind the scenes at Europe's largest MMA venue" },
        excerpt: { fr: "Instagram", de: "Instagram", en: "Instagram" },
      },
      {
        year: "",
        link: "https://www.instagram.com/reel/DZc0B53sqw_/",
        title: { fr: "Face aux crises, Berlin réhabilite ses anciens bunkers", de: "Vor dem Ausbruch der Krisen saniert Berlin seine alten Bunker", en: "With crises looming, Berlin is restoring its old bunkers" },
        excerpt: { fr: "Instagram", de: "Instagram", en: "Instagram" },
      },
      {
        year: "",
        link: "https://www.instagram.com/reel/DY7SuLJB92n/",
        title: { fr: "Carnaval des cultures : l'un des plus grands carnavals du monde", de: "Karneval der Kulturen: einer der größten Karnevale der Welt", en: "Carnival of Cultures: one of the world's biggest carnivals" },
        excerpt: { fr: "Instagram", de: "Instagram", en: "Instagram" },
      },
      {
        year: "",
        link: "https://www.tiktok.com/@piapresents/video/7663500062797942038",
        title: { fr: "Redonner sa grandeur à l'Europe. La nouvelle stratégie de Donald Trump", de: "Europa wieder großartig machen. Die neue Strategie von Donald Trump", en: "Make Europe great again. Donald Trump's new strategy" },
        excerpt: { fr: "TikTok", de: "TikTok", en: "TikTok" },
      },
      {
        year: "",
        link: "https://www.tiktok.com/@piapresents/video/7503310014690381078",
        title: { fr: "Pourquoi l'UE n'exclut pas la Hongrie", de: "Warum die EU Ungarn nicht ausschliesst", en: "Why the EU is not expelling Hungary" },
        excerpt: { fr: "TikTok", de: "TikTok", en: "TikTok" },
      },
      {
        year: "",
        link: "https://www.tiktok.com/@piapresents/video/7051917525684096262",
        title: { fr: "L'Autriche va-t-elle porter plainte contre l'UE ?", de: "Is Austria going to sue the EU?", en: "Is Austria going to sue the EU?" },
        excerpt: { fr: "TikTok", de: "TikTok", en: "TikTok" },
      },
      {
        year: "",
        link: "https://www.tiktok.com/@piapresents/video/7040328423956368645",
        title: { fr: "À quoi ressemble Notre-Dame de Paris deux ans et demi après l'incendie ?", de: "Wie sieht die Notre-Dame de Paris 2,5 Jahre nach dem Brand aus?", en: "What does Notre Dame de Paris look like 2,5 years after the fire?" },
        excerpt: { fr: "TikTok", de: "TikTok", en: "TikTok" },
      },
    ],
  },
];

export const ABOUT_PAGES = [
  {
    id: "artist",
    label: { fr: "Je suis une artiste", de: "Ich bin Künstlerin", en: "I am an artist" },
    img: "/images/about-artist.webp",
    frame: "square",
    paragraphs: {
      fr: [
        "*Je suis une artiste.* Je viens de la scène, et c'est mon point fort. Dès l'enfance, j'ai passé sept ans comme chanteuse et actrice à la Volksoper de Vienne, puis une dizaine d'années comme danseuse professionnelle en championnats internationaux. *Je sais adapter ma façon de m'exprimer à chaque public.*",
        "Aujourd'hui, je mets cette créativité au service de ma passion pour l'interaction humaine et de mon intérêt pour la réalité de la vie des gens et leurs points de vue. *Comme l'art, le journalisme doit évoluer avec chaque génération et sa manière de penser, de comprendre et de communiquer.* Je veux contribuer à cette évolution.",
      ],
      de: [
        "*Ich bin Künstlerin.* Das Scheinwerferlicht ist mein Zuhause und meine größte Stärke. Seit meinem siebten Lebensjahr stand ich als Sängerin und Schauspielerin auf der Bühne der Wiener Volksoper, danach trat ich rund zehn Jahre als professionelle Tänzerin bei internationalen Meisterschaften an. *Ich habe ein Gespür für die Stimmung im Raum und weiß, wie ich mich auf jedes Publikum einstelle.*",
        "Heute fließt diese Kreativität in meine journalistische Arbeit ein. Mich fasziniert der Austausch mit Menschen, ihr Alltag und ihre Sicht auf die Welt. *Wie die Kunst muss sich auch der Journalismus mit jeder Generation weiterentwickeln, mit ihrer Art zu denken, zu verstehen und zu kommunizieren.* Dazu möchte ich beitragen.",
      ],
      en: [
        "*I'm an artist.* The stage is where I come from, and it's my greatest strength. From childhood, I spent seven years as a singer and actress at the Vienna Volksoper, followed by around ten years as a professional dancer at international championships. *I know how to read a room and adapt the way I communicate to every audience.*",
        "Today, I put that creativity to work for my passion for human connection and my curiosity about people's lives and perspectives. *Like art, journalism has to evolve with each generation and the way it thinks, understands and communicates.* I want to help shape that evolution.",
      ],
    },
  },
  {
    id: "formation",
    label: { fr: "Ma formation", de: "Meine Ausbildung", en: "My formation" },
    logos: [
      { src: "/images/logo-esj.png", alt: "ESJ — École supérieure de journalisme" },
      { src: "/images/logo-sciencespo.png", alt: "Sciences Po Lille", big: true },
      { src: "/images/logo-wien.svg", alt: "Universität Wien" },
      { src: "/images/logo-delors.png", alt: "Institut Jacques Delors" },
      { src: "/images/logo-deutschepop.jpg", alt: "Deutsche POP" },
      { src: "/images/logo-uwl.png", alt: "University of West London", big: true },
    ],
    paragraphs: {
      fr: [
        "Mon parcours a commencé en 2019 à Vienne, au campus de la **Deutsche Pop Akademie**, où je me suis formée à la *présentation radio et télévision* ainsi qu'à la rédaction pour la *presse écrite et le web*, en allemand. J'ai ensuite obtenu une première licence en anglais en *Media Reporting* à **l'University of West London**, entièrement à distance en raison de la pandémie de Covid-19.",
        "Mes secondes études, en *communication transculturelle* en allemand, en anglais et en français à **l'Université de Vienne**, m'ont menée à Paris, où j'ai effectué ma L3 à **l'ISIT Panthéon-Assas** en 2021. Après mes premières expériences de présentatrice et de scénariste, j'ai voulu apprendre à mettre en œuvre mes propres idées dans des reportages longs formats de 20 à 25 minutes. J'ai donc intégré le double diplôme master de **l'École supérieure de journalisme de Lille** et de **Sciences Po Lille**, avec une spécialisation en journalisme de télévision, plus précisément en *Journaliste Reporter d'Images*.",
        "Pendant ma première année de master, en 2024, j'ai suivi *l'Académie Notre Europe* à **l'Institut Jacques Delors**, à Paris. Elle m'a permis de découvrir les coulisses de l'Union européenne et surtout de comprendre ses enjeux géopolitiques et les défis de son évolution.",
        "Au cours de ces deux années, j'ai effectué **quatre stages** pour connaître tous les aspects du journalisme télévisé français :",
        "• AFPTV, Vienne : journaliste vidéo au bureau Europe centrale, qui couvre huit pays.",
        "• Wéo, Hauts-de-France : journalisme de proximité à la télévision locale de la région.",
        "• AFPTV, Berlin : renfort vidéo au bureau de Berlin.",
        "• France Télévisions, Berlin : stage de correspondance au bureau de Berlin où j'ai travaillé comme productrice, JRI et journaliste réseaux sociaux.",
        "Je suis aujourd'hui prête à rendre la géopolitique actuelle et ses conséquences plus compréhensibles et plus accessibles aux citoyens, par les mots, en trois langues, et par les images.",
        "**Travaux scientifiques** rédigés au cours de mes études :",
        "• La façon dont le public, auquel s'adresse le média, influence le travail du JRI. Le métier de Journaliste Reporter d'Images : Différences et similitudes entre la télévision locale et l'agence de presse internationale. Sciences Po Lille, 2026.",
        "• Inwiefern wirkt sich der Einsatz von Phraseologismen in der deutschsprachigen journalistischen Berichterstattung auf dessen Relevanz für die junge Bevölkerung aus? Ein Vergleich französischer und deutschsprachiger Berichterstattung sowie deren Methoden. Universität Wien, 2023.",
        "• Fashion and Journalism at the Heart of Cultural Development. Based on the Comparison between Vogue France and British Vogue. University of West London, 2022.",
        "• The Relevance of Twitter in Journalism with a Future Outlook. University of West London, 2022.",
      ],
      de: [
        "Meine akademische Laufbahn startete ich 2019 an der **Akademie Deutsche Pop** in Wien, wo ich eine Ausbildung in *Radio- und Fernsehmoderation* sowie im journalistischen Schreiben für *Print- und Onlinemedien* auf Deutsch absolvierte. Anschließend studierte ich *Media Reporting* an der **University of West London**, auf Englisch und aufgrund der Covid-19-Pandemie online.",
        "Mein zweites Studium, *transkulturelle Kommunikation* auf Deutsch, Englisch und Französisch an der **Universität Wien**, führte mich nach Paris, wo ich 2021 mein drittes Studienjahr am **ISIT Panthéon-Assas** verbrachte. Nach meinen ersten Erfahrungen als Moderatorin und Drehbuchautorin wollte ich lernen, 20-25-minütige Reportagen selbst mit der Kamera umzusetzen. Deshalb absolvierte ich einen Doppelmaster an der **École supérieure de journalisme de Lille** (ESJ Lille) und an **Sciences Po Lille** mit Schwerpunkt *Fernsehjournalismus und Kameraführung* („Journaliste Reporter d'Images“).",
        "Im ersten Masterjahr, 2024, absolvierte ich ebenfalls die *Académie Notre Europe* am **Institut Jacques Delors** in Paris. Dabei erhielt ich Einblicke in die Arbeit der Europäischen Union und vertiefte mein Verständnis ihrer geopolitischen Herausforderungen und ihrer institutionellen Entwicklung.",
        "Während meines zweijährigen Masterstudiums habe ich **vier Praktika** absolviert, um alle Facetten des französischen Fernsehjournalismus kennenzulernen:",
        "• AFPTV, Wien: Videojournalistin im Büro für Zentraleuropa, das acht Länder abdeckt.",
        "• Wéo, Hauts-de-France: Lokaljournalismus beim regionalen Fernsehsender.",
        "• AFPTV, Berlin: Videojournalistin im Berliner Büro.",
        "• France Télévisions, Berlin: Praktikum im Korrespondentenbüro Berlin, wo ich als Produzentin, Kamerajournalistin und Social-Media-Journalistin gearbeitet habe.",
        "Heute möchte ich über das tagesaktuelle Weltgeschehen berichten, geopolitische Zusammenhänge verständlich vermitteln und ihre Auswirkungen auf den Alltag der Menschen sichtbar machen – in drei Sprachen und mit der Kamera.",
        "**Wissenschaftliche Arbeiten**, die ich im Laufe meiner Studien verfasst habe:",
        "• Wie das Publikum, an das sich ein Medium richtet, die Arbeit des_der Kamerajournalist_in beeinflusst. Der Beruf des *Journaliste Reporter d'Images*: Unterschiede und Gemeinsamkeiten zwischen Lokalfernsehen und internationaler Nachrichtenagentur. Sciences Po Lille, 2026 [auf Französisch verfasst]",
        "• Inwiefern wirkt sich der Einsatz von Phraseologismen in der deutschsprachigen journalistischen Berichterstattung auf dessen Relevanz für die junge Bevölkerung aus? Ein Vergleich französischer und deutschsprachiger Berichterstattung sowie deren Methoden. Universität Wien, 2023",
        "• Mode und Journalismus im Kern der kulturellen Entwicklung. Basierend auf einem Vergleich der französischen und der britischen Ausgabe der „Vogue“. University of West London, 2022 [auf Englisch verfasst]",
        "• Die Bedeutung von Twitter im Journalismus mit einem Ausblick auf zukünftige Entwicklungen. University of West London, 2022 [auf Englisch verfasst]",
      ],
      en: [
        "My academic career began in 2019 at the **Academie Deutsche Pop** in Vienna, where I completed a degree in *radio and television presenting*, as well as journalistic writing for *print and online media*, both in German. I then studied *Media Reporting*, in English, at the **University of West London**, studying entirely online because of the Covid-19 pandemic.",
        "My second bachelor degree, in *intercultural communication* in German, English and French at the **University of Vienna**, led me to Paris, where I completed my third year at **ISIT Panthéon-Assas** in 2021. After my first experiences as a presenter and screenwriter for long-form reports, I wanted to take the next step: filming the stories myself. So I integrated the double master's programme of the **École supérieure de journalisme de Lille** (ESJ Lille) and **Sciences Po Lille**, specialising in *television journalism and filming techniques* (“Journaliste Reporter d'Images”).",
        "During the first year of my master's, in 2024, I also attended the *Académie Notre Europe* at the **Jacques Delors Institute** in Paris. It gave me a look behind the scenes of the European Union and, above all, helped me understand its geopolitical stakes and the challenges ahead.",
        "During my masters, I completed **four internships** to get to know every side of French television journalism:",
        "• AFPTV, Vienna: video journalist at the Central Europe bureau, which covers eight countries.",
        "• Wéo, Hauts-de-France: broadcast and camera journalist at the region's TV channel.",
        "• AFPTV, Berlin: video journalist at the Berlin bureau.",
        "• France Télévisions, Berlin: correspondent at the Berlin bureau, working as a producer, camera journalist and social media journalist.",
        "Today, I aim to explain the geopolitical forces shaping our world and show how they affect people's lives — accessible journalism in three languages and compelling visual storytelling.",
        "**Academic work** written during my studies:",
        "• How the audience a news outlet addresses shapes the work of the JRI. The profession of Journaliste Reporter d'Images: differences and similarities between local television and an international news agency. Sciences Po Lille, 2026 [written in French]",
        "• To what extent does the use of phraseological expressions in German-language journalism affect its relevance for young people? A comparison of French and German-language reporting and its methods. University of Vienna, 2023 [written in German]",
        "• Fashion and Journalism at the Heart of Cultural Development. Based on the Comparison between Vogue France and British Vogue. University of West London, 2022",
        "• The Relevance of Twitter in Journalism with a Future Outlook. University of West London, 2022",
      ],
    },
  },
  {
    id: "why_here",
    label: { fr: "Pourquoi", de: "Warum", en: "Why" },
    img: "/images/about-why.webp",
    fullColor: true,
    paragraphs: {
      fr: [
        "• Parce que, dans une société multiculturelle, il est plus important que jamais de comprendre le point de vue de chacun et de regarder au-delà de son propre horizon. C'est la condition d'une démocratie qui fonctionne.",
        "• Parce qu'un même événement se raconte à travers plusieurs perspectives, et qu'aucune ne détient toute la vérité.",
        "• Parce que je noue facilement des liens avec les gens, et je peux ainsi rendre leur point de vue accessible aux autres.",
      ],
      de: [
        "• Weil es in einer multikulturellen Gesellschaft wichtiger denn je ist, die Perspektive des Gegenübers zu verstehen und über den eigenen Horizont hinauszublicken. Nur so kann Demokratie funktionieren.",
        "• Weil dasselbe Ereignis aus vielen Perspektiven erzählt werden kann und keine allein die ganze Wahrheit zeigt.",
        "• Weil ich schnell einen Draht zu Menschen finde und ihre Sichtweise so für andere zugänglich machen kann.",
      ],
      en: [
        "• Because in a multicultural society, it matters more than ever to understand the other person's perspective and to look beyond your own horizon. This is the only way democracy can work.",
        "• Because the same news can be told from many perspectives, and no single one shows the whole truth.",
        "• Because I connect easily with people and can therefore make their point of view accessible to others.",
      ],
    },
  },
];

export const BIO = {
  fr: "25 ans. Dans le journalisme depuis mes 20 ans. Enfance à Vienne, parcours façonné par Sydney, Paris et Berlin, et demain, là où l'actualité aura besoin de moi.",
  de: "25 Jahre alt. Seit meinem 20. Lebensjahr im Journalismus. In Wien aufgewachsen, geprägt von Sydney, Paris und Berlin, und als Nächstes dort, wo das Weltgeschehen mich braucht.",
  en: "25 years old. In journalism since 20. Grew up in Vienna, shaped by Sydney, Paris and Berlin, and now wherever the news needs me next.",
};
